import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import api from '../../services/api';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const MyTickets = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showQrModal, setShowQrModal] = useState(false);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');



    useEffect(() => {
        fetchOrders(1);
    }, [debouncedSearch, selectedDate]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(searchTerm);
        }, 800);

        return () => clearTimeout(timeout);
    }, [searchTerm]);

    const fetchOrders = async (pageNumber = 1) => {
        try {
            setLoading(true);

            const params = new URLSearchParams();
            params.append('page', pageNumber);

            if (debouncedSearch) params.append('search', debouncedSearch);
            if (selectedDate) params.append('date', selectedDate);

            const response = await api.get(`/orders?${params.toString()}`);

            setOrders(response.data.data.data || []);
            setPagination(response.data.data);
            setPage(pageNumber);

        } catch (error) {
            toast.error('Failed to load tickets');
        } finally {
            setLoading(false);
        }
    };

    const renderPagination = () => {
        if (!pagination.last_page) return null;

        const pages = [];
        const current = pagination.current_page;
        const last = pagination.last_page;

        const delta = 1;
        let start = Math.max(2, current - delta);
        let end = Math.min(last - 1, current + delta);

        pages.push(1);

        if (start > 2) pages.push('...');

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < last - 1) pages.push('...');

        if (last > 1) pages.push(last);

        return (
            <nav className="mt-4">
                <ul className="pagination justify-content-center">
                    <li className={`page-item ${current === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link !text-black"
                            onClick={() => fetchOrders(current - 1)}
                        >
                            Previous
                        </button>
                    </li>

                    {pages.map((p, index) =>
                        p === '...' ? (
                            <li key={index} className="page-item disabled">
                                <span className="page-link">…</span>
                            </li>
                        ) : (
                            <li key={index} className="page-item">
                                <button
                                    className={`page-link ${
                                        p === current
                                            ? '!bg-purple-500 !text-white border-0'
                                            : '!text-black hover:!bg-purple-500 hover:!text-white'
                                    }`}
                                    onClick={() => fetchOrders(p)}
                                >
                                    {p}
                                </button>
                            </li>
                        )
                    )}

                    <li className={`page-item ${current === last ? 'disabled' : ''}`}>
                        <button
                            className="page-link !text-black"
                            onClick={() => fetchOrders(current + 1)}
                        >
                            Next
                        </button>
                    </li>
                </ul>
            </nav>
        );
    };

  const handleViewQR = (ticket) => {
    setSelectedTicket(ticket);
    setShowQrModal(true);
  };

  const handleCloseQrModal = () => {
    setShowQrModal(false);
    setSelectedTicket(null);
  };

    const handlePrintQR = () => {
        const printContents = document.getElementById('qr-print-content').innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = `
    <div style="
      display:flex;
      flex-direction:column;
      justify-content:center;
      align-items:center;
      height:100vh;
    ">
      ${printContents}
    </div>
  `;

        window.print();

        document.body.innerHTML = originalContents;
        window.location.reload(); // ✅ restore React properly
    };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'active':
        return 'badge-success';
      case 'used':
        return 'badge-secondary';
      case 'cancelled':
        return 'badge-danger';
      case 'transferred':
        return 'badge-info';
      default:
        return 'badge-secondary';
    }
  };

  const getPaymentStatusBadge = (status) => {
    switch (status) {
      case 'paid':
        return 'badge-success';
      case 'pending':
        return 'bg-purple-200 text-black';
      case 'failed':
        return 'badge-danger';
      case 'refunded':
        return 'badge-info';
      default:
        return 'badge-secondary';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="container-fluid px-4 py-5">
        <div className="text-center py-5">
          <div className="spinner-border !text-purple-500" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-4 py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 mb-0 text-gray-900 font-weight-bold ">
          <i className="fas fa-ticket-alt mr-2"></i>My Tickets
        </h1>

          <div className="mb-8 flex flex-col sm:flex-row gap-4">

              {/* Keyword search */}
              <div className="relative flex-1">
                  <input
                      type="text"
                      placeholder="Search event title"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-12 pr-4 py-3 !border !border-purple-500 rounded-full focus:ring-2 focus:ring-purple-500 outline-none"
                  />
                  <svg
                      className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-purple-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                  >
                      <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                  </svg>
              </div>

              {/* Date search */}
              <div className="relative">
                  <Flatpickr
                      value={selectedDate}
                      options={{ dateFormat: 'Y-m-d', allowInput: true }}
                      onChange={(dates, dateStr) => setSelectedDate(dateStr)}
                      placeholder="Select a date"
                      className="pl-12 pr-4 py-3 !border !border-purple-500 rounded-full outline-none focus:ring-2 focus:ring-purple-500"
                  />

                  <svg
                      className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-purple-500 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                  >
                      <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                  </svg>

                  {selectedDate && (
                      <button
                          type="button"
                          onClick={() => setSelectedDate('')}
                          className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500"
                      >
                          ✕
                      </button>
                  )}
              </div>

          </div>

      </div>

      {orders.length === 0 ? (
        <div className="card shadow">
          <div className="card-body text-center py-5">
            <i className="fas fa-ticket-alt fa-3x text-muted mb-3"></i>
            <h5 className="text-muted">No tickets found</h5>
            <p className="text-muted mb-4">You haven't purchased any tickets yet.</p>
            <a href="/events" className="btn !bg-purple-500 !font-bold text-white px-5 py-3 hover:!bg-purple-600">
              <i className="fas fa-search mr-2"></i>Browse Events
            </a>
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <div key={order.id} className="card shadow mb-4">
              <div className="card-header py-3 d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="m-0 font-weight-bold !text-purple-500">
                    Order #{order.id}
                  </h6>
                  <small className="text-muted">
                    Ordered on {formatDate(order.created_at)}
                  </small>
                </div>
                <div className="text-right">
                  <span className={`badge ${getPaymentStatusBadge(order.payment_status)} mr-2`}>
                    {order.payment_status}
                  </span>
                  <span className="font-weight-bold text-dark">
                    {order.event?.currency}:{parseFloat(order.subtotal).toFixed(2)-parseFloat(order.discount).toFixed(2)}
                  </span>
                </div>
              </div>
              
              <div className="card-body">
                {/* Event Info */}
                <div className="row mb-4">
                  <div className="col-md-2">
                    {order.event?.image ? (
                      <img
                        src={order.event.image}
                        alt={order.event.name}
                        className="img-fluid rounded"
                        style={{ width: '100%', height: '100px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div
                        className="bg-secondary rounded d-flex align-items-center justify-content-center"
                        style={{ width: '100%', height: '100px' }}
                      >
                        <i className="fas fa-calendar-alt fa-2x text-white"></i>
                      </div>
                    )}
                  </div>
                  <div className="col-md-10">
                    <h5 className="font-weight-bold text-gray-900 mb-1">{order.event?.name || order.event?.title || 'Event'}</h5>
                    <p className="text-muted mb-1">
                      <i className="fas fa-map-marker-alt mr-2"></i>
                      {order.event?.location || 'Location TBA'}
                    </p>
                    <p className="text-muted mb-1">
                      <i className="fas fa-calendar mr-2"></i>
                      {order.event?.start_date ? formatDate(order.event.start_date) : 'Date TBA'}
                    </p>
                    {order.event?.organizer && (
                      <p className="text-muted mb-0">
                        <i className="fas fa-user mr-2"></i>
                        Organized by {order.event.organizer.name}
                      </p>
                    )}
                  </div>
                </div>

                {/* Tickets */}
                <div className="border-top pt-3">
                  <h6 className="font-weight-bold text-gray-900 mb-3">
                    <i className="fas fa-ticket-alt text-gray-900 mr-2"></i>
                    Tickets ({order.tickets?.length || 0})
                  </h6>
                  
                  {order.tickets && order.tickets.length > 0 ? (
                    <div className="row">
                      {order.tickets.map((ticket) => {
                        const isSeatTicket = !ticket.category && ticket.seat_map_seat_id;
                        const isGaTicket   = !ticket.category && !ticket.seat_map_seat_id && ticket.seat_map_section_id;
                        const isValet      = ticket.category?.type === 'valet';
                        let ticketLabel;
                        if (isSeatTicket) {
                          ticketLabel = [ticket.section?.name, ticket.seat?.label].filter(Boolean).join(' · ') || 'Reserved Seat';
                        } else if (isGaTicket) {
                          ticketLabel = ticket.section?.name ? ticket.section.name + ' (GA)' : 'General Admission';
                        } else {
                          ticketLabel = ticket.category?.name || 'Ticket';
                        }
                        return (
                        <div key={ticket.id} className="col-md-6 mb-3">
                          <div className="card h-100" style={{ borderLeft: `4px solid ${isValet ? '#8B5CF6' : '#FCD34D'}` }}>
                            <div className="card-body">
                              <div className="d-flex text-gray-900 justify-content-between align-items-start mb-2">
                                <div>
                                  <h6 className="font-weight-bold mb-1 d-flex align-items-center gap-2">
                                    {isValet && (
                                      <span className="inline-flex items-center justify-center rounded-full" style={{ width: 22, height: 22, background: 'linear-gradient(135deg,#8B5CF6,#7C3AED)', flexShrink: 0 }}>
                                        <svg width="12" height="12" fill="none" stroke="white" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                                        </svg>
                                      </span>
                                    )}
                                    {ticketLabel}
                                  </h6>
                                  <p className="text-muted text-gray-900 small mb-1">
                                    Ticket #: {ticket.ticket_number}
                                  </p>
                                  {ticket.attendee_info && (
                                    <p className="text-muted small mb-0">
                                      Attendee: {ticket.attendee_info}
                                    </p>
                                  )}
                                </div>
                                <span className={`badge ${getStatusBadgeClass(ticket.status)}`}>
                                  {ticket.status}
                                </span>
                              </div>

                              {ticket.scanned_at && (
                                <div className="alert border-2 text-green-600 !border-green-600  py-2 px-3 mb-2" role="alert">
                                  <small>
                                    <i className="fas fa-check-circle mr-1"></i>
                                    Scanned on {formatDate(ticket.scanned_at)}
                                  </small>
                                </div>
                              )}

                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <span className="font-weight-bold text-purple-500">
                                  {order.event?.currency}{parseFloat(ticket.price || ticket.category?.price || 0).toFixed(2)}
                                </span>
                                <button
                                  onClick={() => handleViewQR(ticket)}
                                  className="btn btn-sm !border-2 rounded-lg !text-black !border-purple-500 !bg-transparent hover:!bg-purple-500 hover:!text-white"
                                  disabled={order.payment_status !== 'paid'}
                                >
                                  <i className="fas fa-qrcode mr-1"></i>
                                  View QR Code
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="alert border-2 text-purple-500 !border-purple-500 ">
                      <i className="fas fa-exclamation-triangle !mt-1 !text-purple-500 mr-2"></i>
                      No tickets found for this order
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
            {renderPagination()}
        </div>
      )}

      {/* QR Code Modal */}
      {showQrModal && selectedTicket && ReactDOM.createPortal(
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', inset: 0, zIndex: 9999 }}
          onClick={handleCloseQrModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-qrcode mr-2"></i>
                  Ticket QR Code
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseQrModal}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center" id="qr-print-content">
                <div className="mb-3">
                  <h6 className="font-weight-bold">
                    {selectedTicket.category?.name
                      || (selectedTicket.seat_map_seat_id
                          ? [selectedTicket.section?.name, selectedTicket.seat?.label].filter(Boolean).join(' · ')
                          : selectedTicket.section?.name
                            ? selectedTicket.section.name + ' (GA)'
                            : null)
                      || 'Ticket'}
                  </h6>
                  <p className="text-muted small mb-0">
                    Ticket #: {selectedTicket.ticket_number}
                  </p>
                </div>
                
                <div className="bg-white p-4 d-inline-block rounded shadow-sm">
                  <QRCode
                    value={selectedTicket.qr_code}
                    size={256}
                    level="H"
                  />
                </div>
                
                <div className="mt-3">
                  <p className="text-muted small mb-0">
                    QR Code: {selectedTicket.qr_code}
                  </p>
                  <p className="text-muted small">
                    Show this QR code at the event entrance
                  </p>
                </div>
                
                {selectedTicket.status === 'used' && (
                  <div className="alert alert-info mt-3">
                    <i className="fas fa-check-circle mr-2"></i>
                    This ticket has been used
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn !bg-purple-500 !text-white hover:!bg-purple-600"
                  onClick={handlePrintQR}
                >
                  <i className="fas fa-print mr-2"></i>
                  Print Ticket
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default MyTickets;

